import { useSeo } from "../lib/seo";
import { IMAGES } from "../lib/constants";
import { PageHero } from "../components/Common";
import { PageFade, Reveal } from "../components/Motion";
import { Marketplace } from "./Opportunities";

const POINTS = [
  ["Foreclosures", "Trustee sales, judicial foreclosures and lender-controlled assets."],
  ["Bank-owned (REO)", "Properties held by lenders after foreclosure."],
  ["Pre-foreclosure & motivated sellers", "Owners facing financial pressure who may prefer a discreet sale."],
  ["Receivership & note sales", "Court-supervised and debt-related opportunities, where available."],
];

export default function Distressed() {
  useSeo("Oregon Foreclosure & Distressed Commercial Real Estate", "Oregon foreclosure, bank-owned and distressed commercial properties. Sido Holdings searches for opportunities where investors may acquire at an attractive basis, subject to due diligence.");
  return (
    <PageFade>
      <PageHero eyebrow="Special Situations" title="Foreclosures & Distressed Commercial Opportunities." image={IMAGES.warehouse}
        sub="Sido Holdings actively searches for opportunities where an investor may be able to acquire property at an attractive basis, subject to due diligence, availability, legal status, financing, and transaction conditions." />
      <section className="bg-white border-b border-navy/10">
        <div className="container-x grid gap-px bg-navy/10 sm:grid-cols-2 lg:grid-cols-4">
          {POINTS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.06} className="bg-white p-8">
              <h3 className="text-xl font-semibold text-navy">{t}</h3>
              <p className="mt-2 text-sm text-ink/70">{d}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <Marketplace category="distressed" />
    </PageFade>
  );
}
